import React from 'react';
import { useNavigate } from 'react-router-dom';

const ShoulderRegionPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .shoulder-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #dbeafe 0, #f9fafb 45%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .shoulder-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .shoulder-hero {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 28px;
          padding-bottom: 32px;
          border-bottom: 1px solid rgba(148, 163, 184, 0.45);
        }

        .shoulder-hero-left {
          flex: 1 1 280px;
        }

        .shoulder-hero-right {
          flex: 1 1 260px;
          display: flex;
          justify-content: center;
        }

        .shoulder-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(59, 130, 246, 0.12);
          color: #1d4ed8;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 10px;
        }

        .shoulder-tag-dot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #1d4ed8;
        }

        .shoulder-title {
          font-size: clamp(28px, 4vw, 38px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .shoulder-subtitle {
          font-size: 15px;
          max-width: 540px;
          line-height: 1.5;
          color: #4b5563;
        }

        .shoulder-hero-highlights {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 14px 0 16px;
        }

        .shoulder-pill {
          padding: 6px 11px;
          border-radius: 999px;
          background: rgba(15, 23, 42, 0.92);
          color: #f9fafb;
          font-size: 11px;
        }

        .shoulder-cta-row {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 8px;
        }

        .shoulder-btn-primary,
        .shoulder-btn-secondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .shoulder-btn-primary {
          background: #2563eb;
          color: #f9fafb;
          box-shadow: 0 10px 24px rgba(37, 99, 235, 0.35);
        }

        .shoulder-btn-primary:hover {
          transform: translateY(-1px);
          box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
        }

        .shoulder-btn-secondary {
          background: rgba(15, 23, 42, 0.04);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .shoulder-btn-secondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .shoulder-hero-small {
          font-size: 11px;
          margin-top: 10px;
          color: #6b7280;
        }

        .shoulder-hero-image {
          width: 100%;
          max-width: 420px;
          border-radius: 26px;
          object-fit: cover;
        }

        /* STRIPES */
        .shoulder-stripe {
          padding: 30px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.45);
        }

        .shoulder-sectionTitle {
          font-size: 19px;
          font-weight: 700;
          margin-bottom: 8px;
        }

        .shoulder-sectionSubtitle {
          font-size: 13px;
          color: #4b5563;
          margin-bottom: 16px;
        }

        .shoulder-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .shoulder-flexCol {
          flex: 1 1 260px;
        }

        .shoulder-inlineImage {
          width: 100%;
          max-width: 380px;
          border-radius: 22px;
          object-fit: cover;
        }

        .shoulder-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 7px;
        }

        .shoulder-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .shoulder-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          margin-top: 6px;
          background: #2563eb;
          flex-shrink: 0;
        }

        /* 3-COLUMN STRIP FOR ROTATOR CUFF + GH + TRAP */
        .shoulder-triplet {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 16px;
        }

        .shoulder-tile {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .shoulder-tileTitle {
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 4px;
        }

        .shoulder-tileText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TIMELINE STYLE FOR VISIT FLOW */
        .shoulder-timeline {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 10px;
          margin-top: 12px;
        }

        .shoulder-step {
          border-radius: 18px;
          padding: 10px 12px;
          background: rgba(15, 23, 42, 0.03);
        }

        .shoulder-stepLabel {
          font-size: 12px;
          font-weight: 600;
          margin-bottom: 4px;
        }

        .shoulder-stepText {
          font-size: 12px;
          color: #4b5563;
        }

        /* FULL-WIDTH BANNER USING shoulder_banner.jpg */
        .shoulder-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 18px;
        }

        .shoulder-banner img {
          width: 100%;
          height: 230px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .shoulder-banner img {
            height: 270px;
          }
        }

        .shoulder-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.78), transparent 55%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 8px;
        }

        .shoulder-bannerText {
          color: #e5e7eb;
          font-size: 15px;
          max-width: 420px;
        }

        .shoulder-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 6px;
        }

        .shoulder-bannerButtons button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .shoulder-bannerButtons .primary {
          background: #22c55e;
          color: #022c22;
        }

        .shoulder-bannerButtons .secondary {
          background: rgba(15, 23, 42, 0.35);
          color: #f9fafb;
          border: 1px solid rgba(209, 213, 219, 0.7);
        }

        /* BOTTOM WARNING STRIP */
        .shoulder-bottomStrip {
          margin-top: 26px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .shoulder-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .shoulder-bottomText strong {
          color: #fef9c3;
        }

        .shoulder-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .shoulder-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .shoulder-bottomActions .primary {
          background: #2563eb;
          color: #f9fafb;
        }

        .shoulder-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        /* RESPONSIVE */
        @media (max-width: 640px) {
          .shoulder-title {
            font-size: 26px;
          }
          .shoulder-hero {
            padding-bottom: 26px;
          }
        }
      `}</style>

      <div className="shoulder-page">
        <div className="shoulder-inner">
          {/* ===== HERO ===== */}
          <section className="shoulder-hero">
            <div className="shoulder-hero-left">
              <div className="shoulder-tag">
                <span className="shoulder-tag-dot" />
                Shoulder Region Support
              </div>
              <h1 className="shoulder-title">
                Calm shoulder pain and get your arm moving again.
              </h1>
              <p className="shoulder-subtitle">
                The shoulder region includes the joint itself, the rotator cuff, the deltoid, and
                support muscles like the upper trapezius. When they don&apos;t work together, even
                simple reaching can feel like a big deal.
              </p>

              <div className="shoulder-hero-highlights">
                <span className="shoulder-pill">Pain with lifting overhead</span>
                <span className="shoulder-pill">Reaching behind your back is hard</span>
                <span className="shoulder-pill">Rotator cuff irritation or tears</span>
                <span className="shoulder-pill">“Pinching” in the top of the shoulder</span>
              </div>

              <div className="shoulder-cta-row">
                <button
                  className="shoulder-btn-primary"
                  onClick={() => navigate('/appointments')}
                >
                  Book a shoulder visit →
                </button>
                <button
                  className="shoulder-btn-secondary"
                  onClick={() => navigate('/staff')}
                >
                  Meet our therapists
                </button>
              </div>

              <p className="shoulder-hero-small">
                You don&apos;t have to wait for things to “tear more” or “freeze” completely
                to start shoulder-focused PT.
              </p>
            </div>

            <div className="shoulder-hero-right">
              <img
                src="/content/shoulder-region/shoulder_region_hero.jpg"
                alt="Physical therapist assessing a patient’s shoulder"
                className="shoulder-hero-image"
              />
            </div>
          </section>

          {/* ===== STRIPE 1 – WHAT CAN GO WRONG ===== */}
          <section className="shoulder-stripe">
            <div className="shoulder-sectionTitle">What&apos;s happening in the shoulder region?</div>
            <p className="shoulder-sectionSubtitle">
              The shoulder relies on a team: the ball-and-socket joint (GH joint), the rotator cuff,
              the deltoid, and upper trapezius all have to share the load.
            </p>

            <div className="shoulder-flexRow">
              <div className="shoulder-flexCol">
                <ul className="shoulder-list">
                  <li>
                    <span className="shoulder-bullet" />
                    <span>
                      <strong>GH joint irritation:</strong> pain deep in the joint with reaching,
                      especially overhead or out to the side.
                    </span>
                  </li>
                  <li>
                    <span className="shoulder-bullet" />
                    <span>
                      <strong>Rotator cuff overload:</strong> aching or sharp pain with lifting,
                      carrying, or sleeping on that side.
                    </span>
                  </li>
                  <li>
                    <span className="shoulder-bullet" />
                    <span>
                      <strong>Deltoid strain:</strong> soreness at the outer shoulder when raising
                      the arm or lowering it back down.
                    </span>
                  </li>
                  <li>
                    <span className="shoulder-bullet" />
                    <span>
                      <strong>Upper trapezius tightness:</strong> “knot” or burning along the top
                      of the shoulder and neck, often from stress or posture.
                    </span>
                  </li>
                  <li>
                    <span className="shoulder-bullet" />
                    <span>
                      <strong>Impingement-type pain:</strong> pinching at the top of the shoulder
                      when reaching into cabinets or putting on a coat.
                    </span>
                  </li>
                </ul>

                <div className="shoulder-cta-row" style={{ marginTop: '14px' }}>
                  <button
                    className="shoulder-btn-primary"
                    onClick={() => navigate('/appointments')}
                  >
                    See if your shoulder symptoms fit →
                  </button>
                  <button
                    className="shoulder-btn-secondary"
                    onClick={() => navigate('/contact')}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="shoulder-flexCol" style={{ display: 'flex', justifyContent: 'center' }}>
                <img
                  src="/content/shoulder-region/shoulder_rotator_cuff.jpg"
                  alt="Rotator cuff focused assessment with therapist and patient"
                  className="shoulder-inlineImage"
                />
              </div>
            </div>

            <div className="shoulder-triplet">
              <div className="shoulder-tile">
                <div className="shoulder-tileTitle">Rotator cuff (4 muscles)</div>
                <div className="shoulder-tileText">
                  Supraspinatus, Infraspinatus, Teres Minor, and Subscapularis help center the joint
                  and guide smooth motion.
                </div>
              </div>
              <div className="shoulder-tile">
                <div className="shoulder-tileTitle">Deltoid</div>
                <div className="shoulder-tileText">
                  The outer shoulder muscle that lifts the arm; it works best when the cuff is
                  supporting it.
                </div>
              </div>
              <div className="shoulder-tile">
                <div className="shoulder-tileTitle">Upper trap & neighbors</div>
                <div className="shoulder-tileText">
                  Help elevate and stabilize the shoulder blade, but can become tight when they
                  try to do all the work.
                </div>
              </div>
            </div>
          </section>

          {/* ===== STRIPE 2 – HOW PT HELPS (MANUAL + CONTROL) ===== */}
          <section className="shoulder-stripe">
            <div className="shoulder-flexRow">
              <div className="shoulder-flexCol" style={{ order: 2 }}>
                <div className="shoulder-sectionTitle">How physical therapy supports the shoulder region</div>
                <p className="shoulder-sectionSubtitle">
                  We focus on helping your shoulder move smoothly, share the workload between muscles,
                  and handle the motions that matter in your day.
                </p>

                <ul className="shoulder-list">
                  <li>
                    <span className="shoulder-bullet" />
                    <span>
                      <strong>Joint mobilization:</strong> gentle glides at the GH joint to improve
                      space and reduce that &quot;pinching&quot; sensation.
                    </span>
                  </li>
                  <li>
                    <span className="shoulder-bullet" />
                    <span>
                      <strong>Soft-tissue work:</strong> focused treatment to rotator cuff, upper
                      trapezius, and surrounding muscles to calm tension and soreness.
                    </span>
                  </li>
                  <li>
                    <span className="shoulder-bullet" />
                    <span>
                      <strong>Scapular control:</strong> teaching the shoulder blade how to move with
                      the arm so the joint doesn&apos;t have to fight alone.
                    </span>
                  </li>
                  <li>
                    <span className="shoulder-bullet" />
                    <span>
                      <strong>Strength progression:</strong> from gentle isometrics to bands and
                      functional lifts that match your job or sport.
                    </span>
                  </li>
                  <li>
                    <span className="shoulder-bullet" />
                    <span>
                      <strong>Activity tweaks:</strong> small changes to reaching, lifting, or sleep
                      positions to reduce daily irritation.
                    </span>
                  </li>
                </ul>

                <div className="shoulder-cta-row" style={{ marginTop: '14px' }}>
                  <button
                    className="shoulder-btn-primary"
                    onClick={() => navigate('/appointments')}
                  >
                    Start with one shoulder session →
                  </button>
                  <button
                    className="shoulder-btn-secondary"
                    onClick={() => navigate('/insurance')}
                  >
                    Check my insurance
                  </button>
                </div>
              </div>

              <div className="shoulder-flexCol" style={{ order: 1, display: 'flex', justifyContent: 'center' }}>
                <img
                  src="/content/shoulder-region/shoulder_manual_therapy.jpg"
                  alt="Manual therapy applied to the shoulder joint"
                  className="shoulder-inlineImage"
                />
              </div>
            </div>
          </section>

          {/* ===== STRIPE 3 – VISIT FLOW + EXERCISES IMAGE ===== */}
          <section className="shoulder-stripe">
            <div className="shoulder-flexRow">
              <div className="shoulder-flexCol">
                <img
                  src="/content/shoulder-region/shoulder_exercises.jpg"
                  alt="Patient performing shoulder exercises with guidance"
                  className="shoulder-inlineImage"
                />
              </div>

              <div className="shoulder-flexCol">
                <div className="shoulder-sectionTitle">What a shoulder visit may look like</div>
                <p className="shoulder-sectionSubtitle">
                  We keep it practical and straightforward so you know exactly what you&apos;re working on
                  and why.
                </p>

                <div className="shoulder-timeline">
                  <div className="shoulder-step">
                    <div className="shoulder-stepLabel">1. Story & goals</div>
                    <div className="shoulder-stepText">
                      You explain when the pain started, which motions hurt most, and what you want
                      to get back to.
                    </div>
                  </div>
                  <div className="shoulder-step">
                    <div className="shoulder-stepLabel">2. Motion & strength check</div>
                    <div className="shoulder-stepText">
                      We test shoulder range, rotator cuff strength, and how the shoulder blade moves.
                    </div>
                  </div>
                  <div className="shoulder-step">
                    <div className="shoulder-stepLabel">3. Hands-on work</div>
                    <div className="shoulder-stepText">
                      You try specific manual techniques or stretches to see how your shoulder responds.
                    </div>
                  </div>
                  <div className="shoulder-step">
                    <div className="shoulder-stepLabel">4. Simple home plan</div>
                    <div className="shoulder-stepText">
                      You leave with a small group of movements and shoulder-friendly tips that fit your day.
                    </div>
                  </div>
                </div>

                <div className="shoulder-cta-row" style={{ marginTop: '14px' }}>
                  <button
                    className="shoulder-btn-primary"
                    onClick={() => navigate('/appointments')}
                  >
                    Book a shoulder evaluation →
                  </button>
                  <button
                    className="shoulder-btn-secondary"
                    onClick={() => navigate('/contact')}
                  >
                    Talk to our team first
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* ===== FULL-WIDTH BANNER WITH shoulder_banner.jpg ===== */}
          <section className="shoulder-stripe">
            <div className="shoulder-banner">
              <img
                src="/content/shoulder-region/shoulder_banner.jpg"
                alt="Bright physical therapy clinic environment focused on shoulder care"
              />
              <div className="shoulder-bannerOverlay">
                <div className="shoulder-bannerText">
                  Shoulder sessions happen in a calm, supportive clinic setting — enough space to move,
                  enough time to focus on you, not just the joint.
                </div>
                <div className="shoulder-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate('/appointments')}
                  >
                    Schedule my shoulder visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate('/office')}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* ===== BOTTOM WARNING ===== */}
          <section className="shoulder-stripe">
            <div className="shoulder-bottomStrip">
              <div className="shoulder-bottomText">
                If you have a sudden shoulder injury with major weakness, a loud pop, deformity, or
                can&apos;t lift the arm at all,{" "}
                <strong>seek medical or emergency care first.</strong> Physical therapy can then help you
                recover and rebuild strength afterward.
              </div>
              <div className="shoulder-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate('/appointments')}
                >
                  Schedule shoulder PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate('/contact')}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ShoulderRegionPT;
